import { useEffect, useRef } from 'react';
import type { LocalVideoTrack, Participant } from 'livekit-client';
import { useWebinarT } from '@/hooks/useWebinarT';
import ParticipantPlaceholderView from './ParticipantPlaceholderView';

/**
 * Vignette de l'intervenant hors scène : sa capture locale (jamais publiée) à l'emplacement que la
 * disposition lui réserve, atténuée et libellée pour qu'il sache qu'il n'est pas encore en direct.
 */
export default function SpeakerPreviewTile({
  track,
  participant,
}: {
  track: LocalVideoTrack | null;
  participant: Participant;
}) {
  const { t } = useWebinarT('webinars');
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const element = videoRef.current;
    if (!track || !element) return;
    track.attach(element);
    return () => {
      track.detach(element);
    };
  }, [track]);

  return (
    <div className="relative h-full w-full">
      <div className="h-full w-full grayscale brightness-75">
        {track ? (
          <video
            ref={videoRef}
            className="h-full w-full rounded-lg object-cover"
            autoPlay
            muted
            playsInline
            controls={false}
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
          />
        ) : (
          <ParticipantPlaceholderView
            participant={participant}
            widthClass="w-full"
            activeAsset={false}
          />
        )}
      </div>
      <span className="absolute bottom-1 left-1 z-10 rounded bg-black/70 px-1.5 py-0.5 text-[10px] leading-tight text-white">
        {t('webinars:live.notLiveYet')}
      </span>
    </div>
  );
}
